const API_URL = process.env.REACT_APP_API_URL;

function getAuthHeaders() {
  const token = localStorage.getItem('token');
  return {
    'Authorization': `Bearer ${token}`,
    'Content-Type': 'application/json'
  };
}

// Organization
export const registerBusiness = async (data) => {
  const res = await fetch(`${API_URL}/business/register`, {
    method: 'POST', headers: getAuthHeaders(), body: JSON.stringify(data)
  });
  if (!res.ok) throw new Error((await res.json()).error || 'Failed to register business');
  return res.json();
};

export const getOrganization = async () => {
  const res = await fetch(`${API_URL}/business/organization`, { headers: getAuthHeaders() });
  if (!res.ok) throw new Error((await res.json()).error || 'Failed to get organization');
  return res.json();
};

export const updateOrganization = async (data) => {
  const res = await fetch(`${API_URL}/business/organization`, {
    method: 'PATCH', headers: getAuthHeaders(), body: JSON.stringify(data)
  });
  if (!res.ok) throw new Error((await res.json()).error || 'Failed to update organization');
  return res.json();
};

export const getOrganizationStats = async () => {
  const res = await fetch(`${API_URL}/business/organization/stats`, { headers: getAuthHeaders() });
  if (!res.ok) throw new Error((await res.json()).error || 'Failed to get stats');
  return res.json();
};

// Employees
export const inviteEmployee = async (data) => {
  const res = await fetch(`${API_URL}/business/employees/invite`, {
    method: 'POST', headers: getAuthHeaders(), body: JSON.stringify(data)
  });
  if (!res.ok) throw new Error((await res.json()).error || 'Failed to invite employee');
  return res.json();
};

export const getEmployees = async () => {
  const res = await fetch(`${API_URL}/business/employees`, { headers: getAuthHeaders() });
  if (!res.ok) throw new Error((await res.json()).error || 'Failed to get employees');
  return res.json();
};

export const removeEmployee = async (id) => {
  const res = await fetch(`${API_URL}/business/employees/${id}`, {
    method: 'DELETE', headers: getAuthHeaders()
  });
  if (!res.ok) throw new Error((await res.json()).error || 'Failed to remove employee');
  return res.json();
};

export const getEmployeeClients = async (employeeId) => {
  const res = await fetch(`${API_URL}/business/employees/${employeeId}/clients`, { headers: getAuthHeaders() });
  if (!res.ok) throw new Error((await res.json()).error || 'Failed to get employee clients');
  return res.json();
};

// Clients
export const inviteClient = async (data) => {
  const res = await fetch(`${API_URL}/business/clients/invite`, {
    method: 'POST', headers: getAuthHeaders(), body: JSON.stringify(data)
  });
  if (!res.ok) throw new Error((await res.json()).error || 'Failed to invite client');
  return res.json();
};

export const getClients = async () => {
  const res = await fetch(`${API_URL}/business/clients`, { headers: getAuthHeaders() });
  if (!res.ok) throw new Error((await res.json()).error || 'Failed to get clients');
  return res.json();
};

export const verifyClient = async (id) => {
  const res = await fetch(`${API_URL}/business/clients/${id}/verify`, {
    method: 'PATCH', headers: getAuthHeaders()
  });
  if (!res.ok) throw new Error((await res.json()).error || 'Failed to verify client');
  return res.json();
};

export const reassignClient = async (clientId, employeeId) => {
  const res = await fetch(`${API_URL}/business/clients/${clientId}/assign-employee`, {
    method: 'POST', headers: getAuthHeaders(), body: JSON.stringify({ employeeId })
  });
  if (!res.ok) throw new Error((await res.json()).error || 'Failed to reassign client');
  return res.json();
};

// Join
export const getJoinPreview = async (joinToken) => {
  const res = await fetch(`${API_URL}/business/join/${joinToken}`);
  if (!res.ok) throw new Error((await res.json()).error || 'Failed to load organization');
  return res.json();
};

export const joinOrganization = async (joinToken) => {
  const res = await fetch(`${API_URL}/business/join/${joinToken}`, {
    method: 'POST', headers: getAuthHeaders()
  });
  if (!res.ok) throw new Error((await res.json()).error || 'Failed to join');
  return res.json();
};

export const joinByCode = async (code) => {
  const res = await fetch(`${API_URL}/business/join-by-code`, {
    method: 'POST', headers: getAuthHeaders(), body: JSON.stringify({ code })
  });
  if (!res.ok) throw new Error((await res.json()).error || 'Failed to join');
  return res.json();
};

// QR
export const getQRCode = async () => {
  const res = await fetch(`${API_URL}/business/qr`, { headers: getAuthHeaders() });
  if (!res.ok) throw new Error((await res.json()).error || 'Failed to get QR code');
  return res.json();
};

export const regenerateJoin = async () => {
  const res = await fetch(`${API_URL}/business/regenerate-join`, {
    method: 'POST', headers: getAuthHeaders()
  });
  if (!res.ok) throw new Error((await res.json()).error || 'Failed to regenerate');
  return res.json();
};

// Employee invite accept
export const getEmployeeInvitePreview = async (token) => {
  const res = await fetch(`${API_URL}/business/employee-invite/${token}`);
  if (!res.ok) throw new Error((await res.json()).error || 'Invalid invite');
  return res.json();
};

export const acceptEmployeeInvite = async (token) => {
  const res = await fetch(`${API_URL}/business/employee-invite/${token}/accept`, {
    method: 'POST', headers: getAuthHeaders()
  });
  if (!res.ok) throw new Error((await res.json()).error || 'Failed to accept invite');
  return res.json();
};

// Client invite accept
export const getClientInvitePreview = async (token) => {
  const res = await fetch(`${API_URL}/business/client-invite/${token}`);
  if (!res.ok) throw new Error((await res.json()).error || 'Invalid invite');
  return res.json();
};

export const acceptClientInvite = async (token) => {
  const res = await fetch(`${API_URL}/business/client-invite/${token}/accept`, {
    method: 'POST', headers: getAuthHeaders()
  });
  if (!res.ok) throw new Error((await res.json()).error || 'Failed to accept invite');
  return res.json();
};
